'use client';

import { useState, useCallback, useEffect } from 'react';

function useAnimationControl(state, handler) {
    var _a = useState(state), isMounted = _a[0], setMounted = _a[1];
    var handleAnimationEnd = useCallback(function () {
        if (!state) {
            setMounted(false);
            handler && handler();
        }
    }, [state, handler]);
    useEffect(function () {
        if (state) {
            setMounted(true);
        }
    }, [state]);
    return { isMounted: isMounted, handleAnimationEnd: handleAnimationEnd };
}

export { useAnimationControl as default };
//# sourceMappingURL=useAnimationControl.js.map
